module.exports = __webpack_public_path__ + "static/me-b5f8705fd5a519b827065ab6f168fcb5.jpg";